import { trigger, state, style, animate, transition, animateChild, query } from '@angular/animations';

const diveParams = {
  params: {
    distance: '-20px',
    duration: '400ms',
    delay: '0ms',
    easing: 'cubic-bezier(.68, -0.55, .27, 1.55)'
  }
};
const diveEasing = animate('{{ duration }} {{ delay }} {{ easing }}');

export const diveTrigger = trigger('dive', [
  state('in', style({ opacity: 1, transform: 'translateY(0)' })),
  state('out', style({ opacity: 0, transform: 'translateY({{ distance }})' }), diveParams),
  transition('in <=> out', diveEasing, diveParams),
  transition('void => in', [style({ opacity: 0, transform: 'translateY({{ distance }})' }), diveEasing], diveParams)
]);

export const toggleTrigger = trigger('toggle', [
  state('on', style({ opacity: 1 })),
  transition(':enter', [style({ opacity: 0 }), animate(200)])
]);

export const slideTrigger = trigger('slide', [
  state('in', style({ position: 'relative', left: 0 })),
  state('outLeft', style({ position: 'absolute', left: '-100%' })),
  state('outRight', style({ position: 'absolute', left: '100%' })),
  transition('* <=> *', [animate(500), query('@*', animateChild(), { optional: true })])
]);

export const autoHeightTrigger = trigger('autoHeight', [
  state('off', style({ height: '' })),
  state('on', style({ height: '{{ sliderTargetHeight }}' }), {
    params: { sliderTargetHeight: '' }
  }),
  transition('off => on', [style({ height: '{{ sliderHeight }}' }), animate('400ms ease')], {
    params: { sliderHeight: '' }
  })
]);
